// extracted by mini-css-extract-plugin
module.exports = {"container":"PremBot_container__kPg5M"};